import getJSONP, { HOST, BASE_URL } from "./request";
import { getPlatform } from "@utiles/index";

const PLATFORM = getPlatform();
const ajaxUrl = {
  likeAction: {
    global: `${BASE_URL}/article/m_wikiLike`,
    gm99: "//m.gm99.com/article/m_wikiLike",
  },
  getCharLikeNum: {
    global: `${BASE_URL}/article/m_getRoleLikeNum`,
    gm99: "//m.gm99.com/article/m_getRoleLikeNum",
  },
};

/**
 * 点赞or取消点赞
 * gameId: 游戏id，不能为空
 * roleId：角色id，不能为空
 * loginAccount: 玩家账号，不能为空
 * action: 点赞：LIKE，取消点赞：CANCEL_LIKE
 * likeType：点赞类型，ROLE为角色点赞，ARTICLE为文章点赞，PLAY_DATA为阵容点赞，默认ROLE
 */
export const doLikeAction = (data) => {
  return getJSONP(ajaxUrl.likeAction[PLATFORM], data);
};

/**
 * 角色点赞总数+是否已点赞接口
 * gameId: 游戏id，不能为空
 * roleId：角色id，不能为空
 * loginAccount: 玩家账号，不能为空
 */
export const getCharLikeNum = (data) => {
  return getJSONP(ajaxUrl.getCharLikeNum[PLATFORM], data);
};
